<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.75 19.25">
        <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75">
            <path d="M8.75.875H2.625a1.75 1.75 0 00-1.75 1.75v14a1.75 1.75 0 001.75 1.75h10.5a1.75 1.75 0 001.75-1.75V7z"/>
            <path d="M8.75.875V7h6.125"/>
        </g>
    </svg>
</template>